import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnLT: CultureInfo = {
  name: 'en-LT',
  displayName: 'English (Lithuania)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-LT',
  parent: CultureInfoEn
};
